import { constants } from '../../config/constants';
import { carouselActions, recoAnalytics } from '../../utils/recoAnalytics';

const useRecommendedProductsHook = ({ title, slots, products, tenant }) => {
  const onProductClick = (variant) => {
    const country = tenant === constants.TENANT_TYPES.SODIMAC_CL ? 'SOCL' : 'SOPE';
    recoAnalytics.click({
      carouselKey: 'CR_RecommendationCarousel',
      siteName: country,
      action: carouselActions.clickToRate,
      carouselName: title,
      skuId: variant.id,
      podPositionInCarousel: variant.position,
      lengthPodsInCarousel: products.length,
      slotId: slots,
    });
  };

  const onProductImpression = (variant) => {
    recoAnalytics.impression({
      carouselName: title,
      skusViewed: [variant.id],
    });
  };

  return {
    onProductClick,
    onProductImpression,
  };
};

export { useRecommendedProductsHook };
